<template>
    <a v-bind="$attrs" class="button">
        <slot></slot>
    </a>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";

export default class BaseButtonLink extends Vue {}
</script>

<style scoped></style>
